import { Fragment, useContext } from 'react'

import { Text } from '@hhgtech/hhg-components'
import { Article } from 'components/templates/article'
import {
  FEATURE_FLAG,
  ArticleType as ArticleConstType,
  // IS_PRODUCTION,
} from 'interfaces/constants'
import { Article as ArticleType } from 'interfaces/types'
import { useIntl } from 'react-intl'

import { ArticlePageContext } from '.'
import { StyledNextPostWrapper } from './index.styled'
// import { InlineSpotlight, useGetInlineSpotlightIndex } from './inlineSpotlight'
import { ArticleMastheadAd } from './MastheadAd'

export type Props = {
  articles: Array<ArticleType>
  isMobile: boolean
  handleCloseCommentPopup: () => void
  isCommentPopupOpen?: boolean
  commentCount?: number
  setCommentCount?: any
  openAskDoctor?: (e: boolean) => void
}

export const ArticlePageV2 = ({
  articles: propArticles = [],
  isCommentPopupOpen,
  handleCloseCommentPopup,
  commentCount,
  setCommentCount,
  isMobile,
  openAskDoctor,
}: Props) => {
  const { currentArticle } = useContext(ArticlePageContext)
  const { formatMessage: f } = useIntl()
  // const inlineSpotlightIndex = useGetInlineSpotlightIndex(propArticles)

  return (
    <>
      {propArticles.map((article, index) => (
        <Fragment key={index}>
          {index > 0 &&
            index % 2 === 0 &&
            String(currentArticle?.id) === String(article.id) && (
              <ArticleMastheadAd
                className="full-width"
                article={article}
                initialSticky
              />
            )}
          {(FEATURE_FLAG.articleType === ArticleConstType.ArticleType2 ||
            FEATURE_FLAG.articleType === ArticleConstType.ArticleType3) &&
            index > 0 && (
              <StyledNextPostWrapper>
                <Text
                  size={isMobile ? 'xs' : 'md'}
                  color="#8C8C8C"
                  type="bold"
                  style={{
                    textTransform: 'uppercase',
                    ...(!isMobile
                      ? {
                          fontSize: 18,
                        }
                      : {}),
                  }}
                >
                  {f({ id: 'articlePage.nextPostv2' })}
                </Text>
              </StyledNextPostWrapper>
            )}
          <Article
            key={article.id}
            index={index}
            isMobile={isMobile}
            article={article}
            isCommentPopupOpen={isCommentPopupOpen}
            setCommentCount={setCommentCount}
            commentCount={commentCount}
            handleCloseCommentPopup={handleCloseCommentPopup}
            openAskDoctor={openAskDoctor}
          />

          {/* {index === inlineSpotlightIndex && (
            <InlineSpotlight
              spotlightId={
                IS_PRODUCTION
                  ? 'tieu-hoa-cho-tre-0-2-tuoi'
                  : 'che-do-dinh-duong-phu-hop-cho-be'
              }
            />
          )} */}
        </Fragment>
      ))}
    </>
  )
}
